import { createRouter, createWebHistory  } from 'vue-router'
// import store from '@store'
import { storeToRefs } from 'pinia'

import { useLearningAuthStore } from '@stores/auth'
import { isRefreshTokenValid, markSessionExpiredLogout } from '@utils/commonUtil'
// import multiguard from 'vue-router-multiguard'
import {
  saveCustomPosition,
  loadCustomPosition,
  transitionRouterBefore,
  transitionRouterAfter,
  AuthGuard
} from '@router/settingMethods'
// import { AuthGuard } from '@router/guards/AuthGuard'
import Login from '@views/Login.vue'
import Dashboard from '@views/Dashboard.vue'
import History from '@views/History.vue'
import Inquiry from '@views/Inquiry.vue'
import Error from '@views/Error.vue'
import Opening from '@views/Opening.vue'
import Setting from '@views/Setting.vue'
import Maintenance from '@views/Maintenance.vue'

/// / MODULES //////////////////////

// 講座系
import course from '@router/course'

// 新規登録系
import register from '@router/register'

// パスワードリマインダー系
import reminder from '@router/reminder'

// パスワード変更系
import password from '@router/password'

// メールアドレス変更系
import mail from '@router/mail'

// 修了証原本確認（QRコード）
import poa from '@router/poa'

// アカウント新規登録（完了）
// アカウント新規登録（入力）
// アカウント新規登録（確認）
// アカウント情報
// パスワード変更
// 本人情報変更（入力）
// 本人情報変更（確認）
// ログインパスワード変更（完了）
// ログインパスワード変更（入力）
// 退会
import accounts from '@router/accounts'

// const { userLogging } = useLearningAuthStore()

/// / 注意事項 //////////////////////
// ネストされたルートはKeepAliveにバグが存在するため、利用の際は注意してください

/// / レギュレーション //////////////////////
// 生成される回数が多いページはKeepAliveの利用を控える
/**
 * 該当する対象を除外する場合は、以下のパラメータを必ず対象のComponent名で指定すること
 * @param { meta: { excludeKeepAlive } }
 */

const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: '/user/error',
      name: 'Error',
      component: Error,
      props: (route) => ({
        errorType: String(route.query.error_type)
      }),
      meta: {
        title: 'エラー',
        gaTitle: 'エラー',
        excludeKeepAlive: 'Error',
        nav: 'none',
        footer: true
      }
    },
    {
      path: '/user/opening',
      name: 'Opening',
      component: Opening,
      meta: {
        title: 'オープニング',
        gaTitle: 'オープニング',
        header: true,
        nav: 'none',
        footer: true
      }
    },
    {
      path: '/user/login',
      name: 'Login',
      component: Login,
      meta: {
        title: 'ログイン',
        gaTitle: 'ログイン',
        header: true,
        nav: 'none',
        footer: true
      }
    },
    {
      path: '/user/',
      name: 'Dashboard',
      component: Dashboard,
      meta: {
        title: 'マイページ',
        gaTitle: 'マイページ',
        header: true,
        nav: 'none',
        footer: true
      }
    },
    {
      path: '/user/history',
      name: 'History',
      component: History,
      meta: {
        title: '受講履歴（昨年）',
        gaTitle: '受講履歴（昨年）',
        header: true,
        nav: 'none',
        footer: true
      }
    },
    {
      path: '/user/inquiry',
      name: 'Inquiry',
      component: Inquiry,
      meta: {
        title: '問合せ',
        gaTitle: '問合せ',
        header: true,
        nav: 'none',
        footer: true
      }
    },
    {
      path: '/user/setting',
      name: 'Setting',
      component: Setting,
      meta: {
        title: ' ',
        gaTitle: 'メニュー',
        nav: 'back',
        footer: true
      }
    },
    {
      path: '/user/maintenance',
      name: 'Maintenance',
      component: Maintenance,
      meta: {
        title: 'メンテナンス',
        gaTitle: 'メンテナンス',
        header: false,
        nav: 'none',
        footer: true
      }
    },

    ...course,
    ...register,
    ...reminder,
    ...password,
    ...mail,
    ...accounts,
    ...poa
  ],

  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      // ブラウザの戻る/進むボタンがトリガーされた場合
      return savedPosition
    } else {
      // それ以外の場合はページトップにスクロール
      return { x: 0, y: 0 }
    }
  }
})

router.beforeEach((to, from, next) => {
  router.referrer = from
  saveCustomPosition('.contents__main', from, router)
  transitionRouterBefore('.contents__main', from, next)
  const { accessToken } = storeToRefs(useLearningAuthStore())
  const routeName = to.name ?? ''
  const isPublicRoute =
    routeName === 'Login' ||
    routeName === 'Opening' ||
    routeName === 'CertificatePoa' ||
    routeName.includes('Register') ||
    routeName.includes('Reminder') ||
    routeName.includes('Inquiry')
  const isAuthenticated = accessToken.value !== null && isRefreshTokenValid(accessToken.value)
  if (!isPublicRoute && !isAuthenticated) {
    if (accessToken.value !== null) {
      markSessionExpiredLogout()
    }
    next({ name: 'Login' })
  }
  // else next()
})

router.afterEach((to, from) => {
  loadCustomPosition('.contents__main', from, to, router)
  transitionRouterAfter('.contents__main', from)
})

export default router
